import { useLocation, useNavigate } from 'react-router-dom';
import { Header, MobileHeader, TabletHeader } from './Header';

import { Flex } from '@components/Flex';
import { Logo } from '@components/Logo';
import { Roles, useHasRole } from '@connect-carrier/hooks/useHasRole';
import { useTenantTheme } from '@connect-carrier/hooks/useTenantTheme';
import { useTheme } from '@emotion/react';
import { FC } from 'react';
import { useHeaderScreenSizes } from '../../../hooks/useHeaderScreenSizes';
import { ProfileHeader } from './ProfileMenu';

const DesktopHeader: FC = () => {
  const { gray } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const isAdmin = useHasRole(Roles.Admin);
  return (
    <>
      <Flex
        css={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Flex
          gap={1}
          css={{
            alignItems: 'left',
            position: 'relative',
            right: '15px',
            cursor: 'pointer',
          }}
        >
          <Logo color={gray[10]} css={{ margin: ' 7.3px 0 7.3px' }} />
          <h3
            data-testid="logo-header-label"
            css={{
              flexGrow: 0,
              margin: '27.7px 0 26.3px -15.8px',
              fontSize: '21px',
              fontWeight: 'bold',
              fontStretch: 'normal',
              fontStyle: 'normal',
              lineHeight: 'normal',
              letterSpacing: '3px',
              textAlign: 'left',
              color: gray[30],
            }}
          >
            MASTERMIND CONNECT
          </h3>
        </Flex>
        {location.pathname !== '/' && (
          <Flex>
            <Header />
          </Flex>
        )}
        {isAdmin && (
          <h3
            onClick={() => navigate('/user-management')}
            css={{
              fontSize: '16px',
              fontWeight: 'normal',
              fontStretch: 'normal',
              fontStyle: 'normal',
              letterSpacing: 'normal',
              textAlign: 'center',
              position: 'absolute',
              left: 0,
              right: 0,
              color: gray[70],
              width: 'fit-content',
              margin: '0 auto',
            }}
          >
            User Management
          </h3>
        )}
        <Flex>
          <ProfileHeader />
        </Flex>
      </Flex>

      <Flex css={{ width: '100%' }} />
    </>
  );
};

export const CustomerLandingHeader: FC = () => {
  const { desktop, mobile, tablet } = useHeaderScreenSizes();
  const { gray } = useTheme();
  const tenantConfig = useTenantTheme();
  const headerFg = tenantConfig?.theme?.headerFg ?? gray[10];

  return (
    <>
      <header
        css={{
          borderBottom: `1px solid ${gray[80]}`,
          padding: desktop ? '0px 56px' : tablet ? '0 30px' : '0 20px',
        }}
        data-testid="header"
      >
        {desktop && <DesktopHeader />}
        {tablet && <TabletHeader customerSelectionPage headerFg={headerFg} />}
        {mobile && <MobileHeader customerSelectionPage headerFg={headerFg} />}
      </header>
    </>
  );
};
